/**
 * Le titre d'un écran d'ENTRÉE (connexion, langue, onboarding, accueil) : l'en-tête de la librairie
 * (`EnTeteDePanneau`, titre en Almarena), posé au centre, sans filet dessous, en plus gros que celui
 * d'un panneau — un écran plein cadre n'a pas la taille d'un bandeau.
 *
 *   <EnTeteDePanneau titre="Choisis ta langue" sousTitre="…" className={ENTETE_ECRAN} />
 *
 * manque : une taille « héros » à `EnTeteDePanneau` (titre 28 px centré, sans filet) — utile à tous les
 * écrans d'entrée ; en attendant, ces classes la dessinent par-dessus.
 */
export const ENTETE_ECRAN =
  "w-full flex-col border-b-0 p-0 text-center [&_.sf-bandeau-titre]:whitespace-normal [&_.sf-bandeau-titre]:text-[26px] sm:[&_.sf-bandeau-titre]:text-[30px] [&_.sf-sous-titre]:text-[14px]";
